import styled from 'styled-components';

export const CloseButtonContainer = styled.button`
    width: 60px;
    height: 56px;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    font-size: 0;
    transition: opacity 0.1s ease;

    position: absolute;
    top: 0;
    right: 0;

    &:before,
    &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 3px;
        width: 26px;
        background: ${props => props.theme.closeButtonColor};
    }
    &:before {
        transform: rotate(45deg);
    }
    &:after {
        transform: rotate(-45deg);
    }
    &:hover {
        opacity: 0.5;
    }
`;



// WEBPACK FOOTER //
// ./src/components/button/CloseButtonComponentStyle.js